module.exports = __webpack_public_path__ + "static/media/help-desk.3451147a.png";